import type React from "react";

import Error404 from "./pages/Error404";

type DefaultErrorComponentProps = {
  error: unknown;
  reset: () => void;
};

function DefaultErrorComponent({ error, reset }: DefaultErrorComponentProps): React.ReactElement {
  return <Error404 error={error} resetError={reset} />;
}

export default DefaultErrorComponent;
